export let ErrorMessage = {
    required: '',
    invalidEmail: 'Please enter valid email.'
}